import { Box, Typography, useMediaQuery } from '@mui/material';
import * as React from 'react';
import { useTheme } from '@emotion/react';
import Header from '../Header';
import { useNavigate } from 'react-router-dom';

import { TfiShiftLeftAlt } from 'react-icons/tfi';
import { BiLeftArrowAlt } from 'react-icons/bi';
import BackButton from '../BackButton';

function DashboardLayout({ layoutOptions, title }) {
  const { palette, ...theme } = useTheme();
  const [step, setStep] = React.useState(0);
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        backgroundPosition: 'bottom',
        backgroundSize: 'cover',
        backgroundImage: '#000',
      }}
    >
      <Header />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: isMobile ? 'auto' : '90vh',
          width: '100vw',
          paddingTop: isMobile ? '20px' : 0,
          paddingBottom: isMobile ? '20px' : 0,
        }}
      >
        <Box
          sx={{
            width: isMobile ? '98%' : '96%',
            marginTop: isMobile ? '60px' : '4vw',
            justifyContent: 'center',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: 'center',
            height: isMobile ? 'auto' : '87%',
            backdropFilter: 'blur(10px)',
            padding: isMobile ? 1 : 2,
          }}
        >
          <Box
            sx={{
              width: isMobile ? '100%' : '15%',
              justifyItems: 'flex-start',
              height: isMobile ? 'auto' : '100%',
              fontWeight: '800',
              borderRadius: '15px',
              background:
                'linear-gradient(113deg, rgba(30, 66, 6, 0.85) 10.38%, rgba(31, 31, 31, 0.75) 100%),linear-gradient(0deg, #94E161, #94E161)',
              border: '1px solid #94E161',
              padding: isMobile ? '2vw' : '1vw',
              alignItems: 'flex-start',
              marginBottom: isMobile ? '10px' : 0,
            }}
          >
            <BackButton onClick={() => navigate(-1)} />
            <Box
              sx={{
                display: isMobile ? 'flex' : 'block',
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: isMobile ? 'flex-start' : 'center',
              }}
            >
              {layoutOptions?.map((option, i) => {
                return (
                  <Box
                    key={i}
                    onClick={() => {
                      option?.navigate
                        ? navigate(option?.navigate)
                        : setStep(i);
                    }}
                    sx={{
                      cursor: 'pointer',
                      padding: isMobile ? 1 : 2,
                      marginBlock: isMobile ? 1 : 2,
                      marginRight: isMobile ? 1 : 0,
                      borderRadius: '10px',
                      border: step === i ? '1px solid #6F6F6F' : 'none',
                      background: step === i ? '#94E161' : '',
                      minWidth: isMobile ? '120px' : 'auto',
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: '700',
                        fontFamily: 'var(--font-f_r)',
                        fontSize: isMobile ? '14px' : '1vw',
                        textTransform: 'capitalize',
                        textAlign: isMobile ? 'left' : 'center',
                        color: step === i ? '#000' : '#fff',
                        [theme.breakpoints.down('sm')]: {
                          fontSize: '14px',
                        },
                      }}
                    >
                      {option.name}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </Box>
          <Box
            sx={{
              width: isMobile ? '100%' : '85%',
              background: '#000',
              border: '1px solid #29401A',
              marginLeft: isMobile ? 0 : '20px',
              height: isMobile ? 'auto' : '100%',
              minHeight: isMobile ? '70vh' : 'auto',
              borderRadius: '15px',
              overflow: isMobile ? 'hidden' : 'auto',
            }}
          >
            {layoutOptions[step] && layoutOptions[step]?.children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default DashboardLayout;
